export default __webpack_public_path__ + "static/media/shopee_btn.8a0a8b30.webp";